/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobPlan } from "./JobPlan";
export const JobPlanResponse = core.serialization.object({
    data: JobPlan,
});
